import type { ProductType } from '@econtractor/types';
import type { ProductSelectOption } from '../../types';

export const toOption = (product: ProductType): ProductSelectOption => ({
    value: product.ID,
    label: product.prodName,
    vendor: product.vendorName,
    article: product.prodArticle,
    defPrice: product.prodDefPrice,
    defPriceSale: product.prodDefPriceSale,
    dimensionName: product.dimensionName,
    dimensionI18nKey: product.dimensionI18nKey,
});
